import {
  DEFAULT_FILTERS,
  Thread,
  ThreadFilters,
  ThreadItem,
  ThreadStatus,
} from '@/models/thread';
import { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';

interface ThreadContextProps extends Thread {
  status: ThreadStatus;
  setStatus: Dispatch<SetStateAction<ThreadStatus>>;
  handleTitleUpdate: (newTitle: string) => void;
  handlePromptSubmit: (msg: string, filters?: ThreadFilters) => void;
  handleCitationRequest: (block: ThreadItem) => void;
  resetThread: () => void;
}

export const ThreadContext = createContext<ThreadContextProps>({
  id: undefined,
  title: '',
  items: [],
  status: 'READY',
  filters: DEFAULT_FILTERS,
  setStatus: () => ({}),
  handleTitleUpdate: () => ({}),
  handlePromptSubmit: () => ({}),
  handleCitationRequest: () => ({}),
  resetThread: () => ({}),
});
